import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AuthenticationService, Logger } from 'app/core/index';
import { Headers, Http } from '@angular/http';

const logger = new Logger('wager.service.ts');

export interface IWagerData {
  progress: number;
  target: number;
}

@Injectable()
export class WagerService {
  protected wagerData: IWagerData = {
    progress: 0,
    target: 0,
  };

  // FIXME: Hardcoded!
  protected networkId: string = '5c6e91186b561b4c616bd4b7';
  protected nodeId: string = 'WagerCondition';

  protected wagerDataSubject: Subject<IWagerData> = new BehaviorSubject({
    progress: 0,
    target: 0,
  });

  wagerData$: Observable<IWagerData> = this.wagerDataSubject.asObservable();

  constructor(private http: Http, private auth: AuthenticationService) {
    auth.userInfo$.subscribe((user: any) => {
      if (user) {
        this.getWagerData();
      } else {
        this.wagerData = {
          progress: 0,
          target: 0,
        };
        this.wagerDataSubject.next(this.wagerData);
      }
    });
  }

  getWagerData() {
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);
    return this.http
      .get(`/api/components/${this.networkId}/${this.nodeId}`, { headers: headers })
      .toPromise()
      .then((data: any) => {
        data = data.json();
        logger.info('Got component info: ' + JSON.stringify(data));
        if (data.wagerTarget) {
          this.wagerData = {
            progress: data.wagerProgress,
            target: data.wagerTarget,
          };
        } else {
          this.wagerData = {
            progress: 0,
            target: 0,
          };
        }
        this.wagerDataSubject.next(this.wagerData);
        return data;
      });
  }

  setWagerData(wager: IWagerData) {
    logger.info(`Updated wager data (progress: ${JSON.stringify(wager)}`);

    this.wagerDataSubject.next(wager);
    this.wagerData = wager;
  }

  getWagerProgress() {
    return this.wagerData.progress;
  }

  getWagerTarget() {
    return this.wagerData.target;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/wager.service.ts